var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map"},[_c('yandex-map',{attrs:{"coords":_vm.coords,"zoom":16,"controls":['zoomControl', 'typeSelector', 'fullscreenControl']}},[_c('ymap-marker',{attrs:{"coords":_vm.coords,"icon":_vm.icon,"marker-id":"1","hint-content":"Шкотовская улица, 28"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }